import { Planning } from "../../../Domain/Planning/entities/planning.entity";
import { BonEntity } from "../../../Domain/Bons/entities";
import { EntityId } from "@reduxjs/toolkit";

export function useDefaultValueOf(anEntity?: Planning | BonEntity) {
    if ( !anEntity ) return {};

    const { ids } = anEntity;
    let result: {
        client: {
            id: EntityId | undefined,
            label: string,
        },
        chantier: {
            id: EntityId | undefined,
            label: string,
        },
        chauffeur: {
            id: EntityId | undefined,
            label: string,
        },
        interlocuteur: {
            id: EntityId | undefined,
            label: string,
        },
        article: {
            id: EntityId | undefined,
            label: string,
        },
        fournisseur: {
            id: EntityId | undefined,
            label: string,
        },
        commentaire_interne: string,
        consignes_chauffeur: string,
        evenement: string,
        fraisAutoroute?: number,
        confirmedFraisAutoroute?: number,
        observationFournisseur?: string,
        observationClient?: string,
        unite?: string,
    } = {
        client: {
            id: ids?.client,
            label: anEntity.client ?? '',
        },
        chantier: {
            id: ids?.chantier,
            label: anEntity.chantier ?? '',
        },
        chauffeur: {
            id: ids?.chauffeur,
            label: anEntity.chauffeur ?? '',
        },
        interlocuteur: {
            id: ids?.commandePar,
            label: anEntity.commandePar ?? '',
        },
        article: {
            id: ids?.article,
            label: anEntity.article ?? '',
        },
        fournisseur: {
            id: ids?.fournisseur,
            label: anEntity.fournisseur ?? '',
        },
        commentaire_interne: anEntity.commentaire_interne ?? '',
        consignes_chauffeur: anEntity.consignes_chauffeur ?? '',
        evenement: anEntity.evenement ?? '',
        unite: anEntity.unite ?? '',
    }

    if ( 'confirmedFraisAutoroute' in anEntity || 'fraisAutoroute' in anEntity ) {
        result = {
            ...result,
            fraisAutoroute: anEntity.fraisAutoroute ?? 0,
            confirmedFraisAutoroute: anEntity.confirmedFraisAutoroute ?? 0
        };
    }
    if ( 'procedure' in anEntity) {
        result = {
            ...result,
            observationClient: anEntity.procedure?.observations.client,
            observationFournisseur: anEntity.procedure?.observations.fournisseur
        };
    }

    return result;
}